<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> OTA Batch Report</span>
    </div>
  </div>

  <!-- List Section -->
  <form [formGroup]="otaReportForm" novalidate>
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">OTA Batch Report Filter Details</h6>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <div class="component-body">
        <div class="form-section">
          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>From Date</mat-label>
              <input
                formControlName="fromDate"
                matInput
                [matDatepicker]="fromDate"
                [max]="today"
                [max]="otaReportForm.value.toDate || today"
                id="fromDate"
                placeholder="From Date"
                readonly
              />
              <mat-datepicker-toggle matSuffix [for]="fromDate">
              </mat-datepicker-toggle>
              <mat-datepicker #fromDate></mat-datepicker>
              @if (
                otaReportForm.controls['fromDate'].touched &&
                otaReportForm.controls['fromDate'].errors?.required
              ) {
                <mat-error> This field is mandatory. </mat-error>
              }
              @if (
                otaReportForm.controls['fromDate'].hasError('invalidDateRange')
              ) {
                <mat-error>
                  From Date should not be greater than To Date.
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>To Date</mat-label>
              <input
                formControlName="toDate"
                matInput
                [matDatepicker]="toDate"
                id="toDate"
                [max]="today"
                [min]="otaReportForm.value.fromDate || ''"
                placeholder="To Date"
                readonly
              />
              <mat-datepicker-toggle matSuffix [for]="toDate">
              </mat-datepicker-toggle>
              <mat-datepicker #toDate></mat-datepicker>
              @if (
                otaReportForm.controls['toDate'].touched &&
                otaReportForm.controls['toDate'].errors?.required
              ) {
                <mat-error> This field is mandatory. </mat-error>
              }
              @if (
                otaReportForm.controls['toDate'].hasError('invalidDateRange')
              ) {
                <mat-error>
                  To Date should not be lesser than From Date.
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>From Batch ID</mat-label>
              <input
                type="number"
                formControlName="fromBatchId"
                matInput
                id="fromBatchId"
                [max]="otaReportForm.value.toBatchId || null"
                [min]="1"
                placeholder="From Batch Id"
              />
              @if (
                otaReportForm.controls['fromBatchId'].touched &&
                otaReportForm.controls['fromBatchId'].errors?.required
              ) {
                <mat-error> This field is mandatory. </mat-error>
              }
              @if (
                otaReportForm.controls['fromBatchId'].hasError(
                  'invalidBatchIdRange'
                )
              ) {
                <mat-error>
                  From Batch ID should not be greater than To Batch ID.
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>To Batch ID</mat-label>
              <input
                type="number"
                formControlName="toBatchId"
                matInput
                id="toBatchId"
                [min]="otaReportForm.value.fromBatchId || 1"
                placeholder="To Batch ID"
              />
              @if (
                otaReportForm.controls['toBatchId'].touched &&
                otaReportForm.controls['toBatchId'].errors?.required
              ) {
                <mat-error> This field is mandatory. </mat-error>
              }
              @if (
                otaReportForm.controls['toBatchId'].hasError(
                  'invalidBatchIdRange'
                )
              ) {
                <mat-error>
                  To Batch ID should not be lesser than From Batch ID.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>
      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        <div class="button-group">
          <button type="button" (click)="getReports()" class="submit-button">
            Submit <mat-icon class="btn-icon">check_circle</mat-icon>
          </button>
          <button type="button" (click)="clear()" class="clear-button">
            Clear <mat-icon class="btn-icon">clear</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Ongoing OTA Device Report</h6>
        <div class="component-actions">
          <button
            class="primary-button"
            type="button"
            [disabled]="isDownloading"
            (click)="downloadAllOTAPendingDevicesReport()"
          >
            All Devices under OTA process<mat-icon class="btn-icon"
              >download</mat-icon
            >
          </button>
          <button
            type="button"
            class="primary-button"
            [disabled]="listOfData.length === 0 || isDownloading"
            (click)="downloadOtaOverallBatchDeviceReport()"
          >
            Device in Batch OTA Report<mat-icon class="btn-icon"
              >download</mat-icon
            >
          </button>
          <button
            type="button"
            class="primary-button"
            [disabled]="listOfData.length === 0 || isDownloading"
            (click)="downloadOtaBatchSummaryReport()"
          >
            Batch Summary Report<mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Batch ID</th>
              <th>Total Device Uploaded</th>
              <th>Total Device Completed</th>
              <th>Total Device Aborted</th>
              <th>Total Device In-progress/Pending</th>
              <th>Batch Percentage</th>
            </tr>
          </thead>
          @if (listOfData.length !== 0) {
            <tbody>
              @for (
                item of listOfData
                  | paginate
                    : {
                        id: 'otaBatchReportPaginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: listOfData.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.batchId }}</td>
                  <!-- <td>{{ item.BatchDate | date : "dd MMM yyyy" }}</td> -->
                  <td>{{ item.totalDevices }}</td>
                  <td>{{ item.completedDevices }}</td>
                  <td>{{ item.abortedDevices }}</td>
                  <td>{{ item.pendingDevices }}</td>
                  <td>
                    {{
                      item.totalDevices
                        ? (
                            ((item.completedDevices + item.abortedDevices) /
                              item.totalDevices) *
                            100
                          ).toFixed(2) + ' %'
                        : '0 %'
                    }}
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (listOfData.length === 0) {
            <tbody>
              <tr>
                <td colspan="9">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (listOfData.length !== 0) {
          <app-common-component-pagination
            [totalItems]="listOfData.length"
            [pageSize]="size"
            [currentPage]="page"
            [totalPages]="listOfData.length"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  </form>
</div>
